
/* eslint-disable */

import {
    defineComponent, PropType,
} from '@vue/composition-api';

import IsExclusiveFilterSerp from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilterSerp.vue';
import MealsFilterList from '@ve/components/filters/mealsFilter/desktop/MealsFilterList.vue';
import HotelCategoriesFilterList from '@ve/components/filters/hotelCategoriesFilter/desktop/HotelCategoriesFilterList.vue';
import BudgetFilter from '@ve/components/filters/budgetFilter/desktop/BudgetFilter.vue';
import DirectFlightFilterDesktopSerp from '@ve/components/searchFilters/directFlightFilter/desktop/DirectFlightFilterDesktopSerp.vue';
import WarrantedFilterDesktop from '@ve/components/searchFilters/warrantedFilter/desktop/WarrantedFilterDesktopSerp.vue';
import ResortFilter from '@ve/pages/serp/components/filters/resortFilter/desktop/ResortFilterWrapper.vue';
import BeachOwnerFilter from '@ve/components/filters/beachOwnerFilter/BeachOwnerFilterWrapper.vue';
import BeachLineFilter from '@fr/vue/components/filters/beachLineFilter/BeachLineWrapperFilter.vue';
import { HotelCategoryForFilter } from '@ve/components/filters/hotelCategoriesFilter/common/types';
import RatingReviewsFilter from '@ve/components/filters/ratingReviewsFilter/RatingReviewsFilterWrapper.vue';
import DistanceLiftFilter from '@fr/vue/components/filters/distanceLiftFilter/DistanceListFilterWrapper.vue';
import FacilitiesFilter from '@ve/components/filters/facilitiesFilter/FacilitiesFilter.vue';
import ServiceChildFilter from '@ve/components/filters/serviceChildFilter/ServiceChildFilter.vue';
import RestTypeFilter from '@ve/components/filters/restTypeFilter/RestTypeFilterWrapper.vue';
import NearCenterFilter from '@ve/components/filters/nearCenterFilter/NearCenterFilter.vue';

import FilterBySearchHotel from './components/filterBySearchHotelWrapper/FilterBySearchHotelWrapper.vue';
import FilterBeachType from './components/filterBeachType/FilterBeachType.vue';
import FilterWaterActivities from './components/filterWaterActivities/FilterWaterActivities.vue';
import FilterOperators from './components/filterOperators/FilterOperators.vue';
import FiltersList from './FiltersList.vue';
import FiltersListSticky from './FiltersListSticky.vue';
import FilterPostWrapper from './FilterPostWrapper.vue';
import FiltersListSection from './FiltersListSection.vue';

export default defineComponent({
    name: 'filters-serp',
    components: {
        IsExclusiveFilterSerp,
        FiltersList,
        FiltersListSticky,
        FilterPostWrapper,
        FiltersListSection,
        MealsFilterList,
        HotelCategoriesFilterList,
        BudgetFilter,
        DirectFlightFilterDesktopSerp,
        WarrantedFilterDesktop,
        FilterBySearchHotel,
        BeachOwnerFilter,
        ResortFilter,
        BeachLineFilter,
        RatingReviewsFilter,
        DistanceLiftFilter,
        RestTypeFilter,
        FacilitiesFilter,
        ServiceChildFilter,
        NearCenterFilter,
        FilterBeachType,
        FilterWaterActivities,
        FilterOperators,
    },
    props: {
        categoriesList: {
            required: true,
            type: Array as PropType<HotelCategoryForFilter[]>,
        },
        resortVisible: {
            type: Boolean,
            default: () => true,
        },
        operatorVisible: {
            type: Boolean,
            default: true,
        },
        directFlightVisible: {
            type: Boolean,
            default: true,
        },
    },
});
